module.exports = __webpack_public_path__ + "img/brand-suzuki.cd8f13c7.png";